import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

export default function ActionCard({ onAddSkill, addingSkill, onCreateWithIris, onDropFile }) {
    const { t } = useTranslation('chat');
    const [isDraggingOver, setIsDraggingOver] = useState(false);

    const handleDragOver = (event) => {
        event.preventDefault();
        if (!addingSkill) setIsDraggingOver(true);
    };

    const handleDragLeave = (event) => {
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setIsDraggingOver(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDraggingOver(false);
        if (addingSkill) return;
        const file = event.dataTransfer.files?.[0];
        if (file) onDropFile?.(file);
    };

    if (addingSkill) {
        return (
            <div className="skill-action-card skill-action-card--loading" data-testid="skills-manager-action-card">
                <CircularProgress size={40} thickness={4} />
            </div>
        );
    }

    if (isDraggingOver) {
        return (
            <div
                className="skill-action-card skill-action-card--dropzone"
                data-testid="skills-manager-action-card"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <img src="/imagens/new-upload.svg" alt="" className="skill-action-card-icon" />
                <p className="skill-action-card-dropzone-text">{t('skills_manager_dropzone_text')}</p>
            </div>
        );
    }

    return (
        <div className="skill-action-card" data-testid="skills-manager-action-card">
            <button
                type="button"
                className="skill-action-card-button"
                onClick={onAddSkill}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                data-testid="skills-manager-add-skill-button"
            >
                <img src="/imagens/new-upload.svg" alt="" className="skill-action-card-icon" />
                <span className="skill-action-card-label">{t('skills_manager_add_button')}</span>
            </button>
            <div className="skill-action-card-divider" />
            <button
                type="button"
                className="skill-action-card-button"
                onClick={onCreateWithIris}
                data-testid="skills-manager-create-with-iris-button"
            >
                <img src="/imagens/skills-create-with-iris-icon.svg" alt="" className="skill-action-card-icon" />
                <span className="skill-action-card-label">{t('skills_manager_create_with_iris_button')}</span>
            </button>
        </div>
    );
}
